import {cva} from 'class-variance-authority'

/**
 * Alert (v3, MUI-aligned). `severity` × `style`.
 * - `light` — tinted background, colored text + icon.
 * - `dark` — solid color background, white text + icon.
 *
 * Colors are the alert-specific component tokens from Figma (tints/solids differ
 * slightly from the global palette), so they're inlined here.
 */
export const AlertVariantsFactory = cva('flex min-w-[270px] gap-2 rounded-lg p-2 font-sans', {
  variants: {
    severity: {
      info: '',
      success: '',
      warning: '',
      error: '',
      flagged: '',
      cta: '',
    },
    variant: {
      standard: '',
      filled: 'text-white',
    },
  },
  compoundVariants: [
    // standard = tint background + colored content
    {severity: 'info', variant: 'standard', class: 'bg-[#edfdff] text-[#00bacc]'},
    {severity: 'success', variant: 'standard', class: 'bg-[#f3ffed] text-[#53b529]'},
    {severity: 'warning', variant: 'standard', class: 'bg-[#fff8e6] text-[#f79600]'},
    {severity: 'error', variant: 'standard', class: 'bg-[#ffe9ec] text-[#d00019]'},
    {severity: 'flagged', variant: 'standard', class: 'bg-[#ffeaf7] text-[#ff1aa2]'},
    {severity: 'cta', variant: 'standard', class: 'bg-[#edfffa] text-[#2adbaa]'},
    // filled = solid background + white content (text-white from `style`)
    {severity: 'info', variant: 'filled', class: 'bg-[#00bacc]'},
    {severity: 'success', variant: 'filled', class: 'bg-[#65d237]'},
    {severity: 'warning', variant: 'filled', class: 'bg-[#f7a900]'},
    {severity: 'error', variant: 'filled', class: 'bg-[#d00019]'},
    {severity: 'flagged', variant: 'filled', class: 'bg-[#ff1aa2]'},
    {severity: 'cta', variant: 'filled', class: 'bg-[#2adbaa]'},
  ],
  defaultVariants: {
    severity: 'info',
    variant: 'standard',
  },
})
